// extracted by mini-css-extract-plugin
module.exports = {"subService":"Subservice_subService__2zhNV","iconContainer":"Subservice_iconContainer__3uvkd","title":"Subservice_title__3oN47","body":"Subservice_body__gQK04"};